import React from "react";
import { ISelectProps, Select } from "../Select/Select";
import styles from "./MultiSelect.scss";
import { components, MultiValueRemoveProps } from "react-select";
import searchIcon from "~assets/search-red.svg";
import deleteIcon from "~assets/delete.svg";
import { tx } from "netbank-shared/src/libs/i18n";

interface IMultiSelectProps extends ISelectProps<true> {}

const IndicatorsContainer = () => <img className={styles.searchIcon} src={searchIcon} alt={tx(`misc.search`)} />;

const MultiValueRemove = (props: MultiValueRemoveProps) => (
  <components.MultiValueRemove {...props}>
    <div className={styles.valueRemove}>
      <img className={styles.icon} src={deleteIcon} alt={tx(`misc.delete`)} />
    </div>
  </components.MultiValueRemove>
);

export const MultiSelect = (props: IMultiSelectProps) => {
  return (
    <Select
      isMulti
      components={{
        DropdownIndicator: () => null,
        IndicatorsContainer,
        MultiValueRemove,
      }}
      {...props}
    />
  );
};
